module.exports = __webpack_public_path__ + "static/media/fitinn2.cd15c325.jpeg";